<template>
  <!-- User List Dialog -->
  <lb-dialog 
    v-model="internalValue" 
    heading="User list" 
    width="70%"
  >
    <template v-slot:body>
      <div class="d-flex flex-column gap-3">
        <!-- Local Preparer Section -->
        <v-card class="d-flex flex-column pa-4 usercard">
          <h5 class="font-size-md mb-4">{{ localPreparerLabel }}</h5>
          <div class="d-flex flex-wrap gap-3">
            <template v-if="(commentaryRuData.submitter_detail || []).length > 0">
              <v-chip 
                v-for="(user, index) in commentaryRuData.submitter_detail" 
                :key="index" 
                text 
                :color="getUserChipColor(user._id)" 
                :class="['email-chip', getChipClass(user._id)]"
              >
                <v-avatar left class="mr-2">
                  <v-icon>mdi-account-outline</v-icon>
                </v-avatar>
                <div class="name-email">
                   <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                   <span v-if="user.name && user.name.trim() && user.email"> - </span>
                   <span class="textLowercase">{{ user.email }}</span>
                 </div>
              </v-chip>
            </template>
            <div class="text-caption grey--text" v-else>
              No Users assigned
            </div>
          </div>
        </v-card>

        <!-- Local Approver Section -->
        <v-card class="d-flex flex-column pa-4 usercard">
          <h5 class="font-size-md mb-4">{{ localApproverLabel }}</h5>
          <div class="d-flex flex-wrap gap-3">
            <template v-if="(commentaryRuData.approver_detail || []).length > 0">
              <v-chip 
                v-for="(user, index) in commentaryRuData.approver_detail" 
                :key="index" 
                text 
                :color="getUserChipColor(user._id)" 
                :class="['email-chip', getChipClass(user._id)]"
              >
                <v-avatar left class="mr-2">
                  <v-icon>mdi-account-outline</v-icon>
                </v-avatar>
                <div class="name-email">
                  <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                  <span v-if="user.name && user.name.trim() && user.email"> - </span>
                  <span class="textLowercase">{{ user.email }}</span>
                </div>
              </v-chip>
            </template>
            <div class="text-caption grey--text" v-else>
              No Users assigned
            </div>
          </div>
        </v-card>

        <!-- Regional Approver Section -->
        <v-card class="d-flex flex-column pa-4 usercard">
          <h5 class="font-size-md mb-4">{{ regionalApproverLabel }}</h5>
          <div class="d-flex flex-wrap gap-3">
            <template v-if="(commentaryRuData.regional_approver_detail || []).length > 0">
              <v-chip 
                v-for="(user, index) in commentaryRuData.regional_approver_detail" 
                :key="index" 
                text 
                :color="getUserChipColor(user._id)" 
                :class="['email-chip', getChipClass(user._id)]"
              >
                <v-avatar left class="mr-2">
                  <v-icon>mdi-account-outline</v-icon>
                </v-avatar>
                <div class="name-email">
                  <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                  <span v-if="user.name && user.name.trim() && user.email"> - </span>
                  <span class="textLowercase">{{ user.email }}</span>
                </div>
              </v-chip>
            </template>
            <div class="text-caption grey--text" v-else>
              No Users assigned
            </div>
          </div>
        </v-card>

        <!-- Manager Section -->
        <v-card class="d-flex flex-column pa-4 usercard">
          <h5 class="font-size-md mb-4">Manager</h5>
          <div class="d-flex flex-wrap gap-3">
            <template v-if="(commentaryRuData.manager_detail || []).length > 0">
              <v-chip 
                v-for="(user, index) in commentaryRuData.manager_detail" 
                :key="index" 
                text 
                :color="getUserChipColor(user._id)" 
                :class="['email-chip', getChipClass(user._id)]"
              >
                <v-avatar left class="mr-2">
                  <v-icon>mdi-account-outline</v-icon>
                </v-avatar>
                <div class="name-email"><span>{{ user.name }}</span> - <span class="textLowercase">{{ user.email }}</span></div>
              </v-chip>
            </template>
            <div class="text-caption grey--text" v-else>
              No Users assigned
            </div>
          </div>
        </v-card>

        <!-- Admin Approver Section -->
        <v-card class="d-flex flex-column pa-4 usercard">
          <h5 class="font-size-md mb-4">Admin Approver</h5>
          <div class="d-flex flex-wrap gap-3">
            <template v-if="(commentaryRuData.admin_approver_detail || []).length > 0">
              <v-chip 
                v-for="(user, index) in commentaryRuData.admin_approver_detail" 
                :key="index" 
                text 
                :color="getUserChipColor(user._id)" 
                class="email-chip"
              >
                <v-avatar left class="mr-2">
                  <v-icon>mdi-account-outline</v-icon>
                </v-avatar>
                <div class="name-email">
                  <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                  <span v-if="user.name && user.name.trim() && user.email"> - </span>
                  <span class="textLowercase">{{ user.email }}</span>
                </div>
              </v-chip>
            </template>
            <div class="text-caption grey--text" v-else>
              No Users assigned
            </div>
          </div>
        </v-card>

        <!-- Admin Preparer Section -->
        <v-card class="d-flex flex-column pa-4 usercard">
          <h5 class="font-size-md mb-4">Admin Preparer</h5>
          <div class="d-flex flex-wrap gap-3">
            <template v-if="(commentaryRuData.admin_preparer_detail || []).length > 0">
              <v-chip 
                v-for="(user, index) in commentaryRuData.admin_preparer_detail" 
                :key="index" 
                text 
                :color="getUserChipColor(user._id)" 
                class="email-chip"
              >
                <v-avatar left class="mr-2">
                  <v-icon>mdi-account-outline</v-icon>
                </v-avatar>
                <div class="name-email">
                  <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                  <span v-if="user.name && user.name.trim() && user.email"> - </span>
                  <span class="textLowercase">{{ user.email }}</span>
                </div>
              </v-chip>
            </template>
            <div class="text-caption grey--text" v-else>
              No Users assigned
            </div>
          </div>
        </v-card>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
/**
 * UserListDialog Component
 * 
 * Displays a dialog showing all users assigned to different roles
 * in the reporting unit (RU) for variance analysis.
 * 
 * Roles displayed:
 * - Local Preparer
 * - Local Approver
 * - Regional Approver
 * - Manager
 * - Admin Approver
 * - Admin Preparer
 * 
 * @component
 * @example
 * <UserListDialog
 *   v-model="userlistdialog"
 *   :commentary-ru-data="commentaryrudata"
 *   :userid="userid"
 *   :multi-role-users="multiRoleUsers"
 *   :local-preparer-label="localPreparerLabel"
 *   :local-approver-label="localApproverLabel"
 *   :regional-approver-label="regionalApproverLabel"
 * />
 */
export default {
  name: 'UserListDialog',

  props: {
    /**
     * Controls dialog visibility (v-model)
     * @type {Boolean}
     */
    value: {
      type: Boolean,
      default: false
    },

    /**
     * Commentary RU data containing user details for different roles
     * @type {Object}
     * @property {Array} submitter_detail - Local preparers
     * @property {Array} approver_detail - Local approvers
     * @property {Array} regional_approver_detail - Regional approvers
     * @property {Array} manager_detail - Managers
     * @property {Array} admin_approver_detail - Admin approvers
     * @property {Array} admin_preparer_detail - Admin preparers
     */
    commentaryRuData: {
      type: Object,
      default: () => ({})
    },

    /**
     * Current logged-in user's ID
     * Used to highlight the current user's chip
     * @type {String}
     */
    userid: {
      type: String,
      default: ''
    },

    /**
     * Set of user IDs who have multiple roles
     * Used to apply special styling
     * @type {Set}
     */
    multiRoleUsers: {
      type: Set,
      default: () => new Set()
    },

    /**
     * Label for Local Preparer section
     * @type {String}
     */
    localPreparerLabel: {
      type: String,
      default: 'Local Preparer'
    },

    /**
     * Label for Local Approver section
     * @type {String}
     */
    localApproverLabel: {
      type: String,
      default: 'Local Approver'
    },

    /**
     * Label for Regional Approver section
     * @type {String}
     */
    regionalApproverLabel: {
      type: String,
      default: 'Regional Approver'
    }
  },

  data() {
    return {
      /**
       * Internal value for v-model support
       */
      internalValue: this.value
    };
  },

  watch: {
    /**
     * Watch for external value changes
     * Updates internal state when parent changes value
     */
    value(newVal) {
      this.internalValue = newVal;
    },

    /**
     * Watch for internal value changes
     * Emits input event to update parent v-model
     */
    internalValue(newVal) {
      this.$emit('input', newVal);
    }
  },

  methods: {
    /**
     * Get chip color based on user ID
     * Highlights current user's chip with primary color
     * @param {String} userId - User's ID
     * @returns {String} Color name for the chip
     */
    getUserChipColor(userId) {
      return this.userid === userId ? 'primary' : 'grey lighten-4';
    },

    /**
     * Get icon color for user chip
     * Highlights current user's icon
     * @param {String} userId - User's ID
     * @returns {String} Color for the icon (empty string for default)
     */
    getIconColor(userId) {
      return this.userid === userId ? '' : '';
    },

    /**
     * Get CSS classes for user chip
     * Applies special highlighting for users with multiple roles
     * and for the current user
     * @param {String} userId - User's ID
     * @returns {String} CSS class names
     */
    getChipClass(userId) {
      const classes = [];
      
      // Highlight users with multiple roles
      if (this.multiRoleUsers.has(userId)) {
        classes.push('highlight-chip');
        
        // Extra highlight if it's the current user
        if (this.userid === userId) {
          classes.push('highlight-chip--self');
        }
      }
      
      return classes.join(' ');
    }
  }
};
</script>

<style scoped>
/**
 * Styles for user list dialog
 */

/* Border styles for different role sections */
.border-left-info {
  border-left: 4px solid var(--v-info-base);
}

.border-left-warning {
  border-left: 4px solid var(--v-warning-base);
}

.border-left-success {
  border-left: 4px solid var(--v-success-base);
}

.border-left-grey {
  border-left: 4px solid var(--v-grey-base);
}

/* Highlight chip for users with multiple roles */
.highlight-chip {
  color: #c62828 !important;
  border: 1px solid #c62828 !important;
}

.highlight-chip .v-icon {
  color: #c62828 !important;
}

/* Extra highlight for current user with multiple roles */
.highlight-chip--self {
  font-weight: 600 !important;
  box-shadow: 0 0 8px rgba(198, 40, 40, 0.35);
  background-color: #ffebee !important;
}

</style>